export const urlConstants = {
  terms: "https://stridist.com/terms",
  privacy: "https://stridist.com/privacy",
};
